/**
 * @typedef Initiators
 * @property {'worker'} WORKER
 * @property {'operator'} OPERATOR
 * @property {'timer'} TIMER
 * @property {'1c'} 1C
 * @property {'import'} IMPORT
 * @property {'forest'} FOREST
 * @property {'employer'} EMPLOYER
 * @property {'supervisor'} SUPERVISOR
 * @property {'zvonobot'} ZVONOBOT
 * @property {'integration'} INTEGRATION
 */

/** @type {Readonly<Initiators>} */
const INITIATORS = Object.freeze({
  WORKER: 'worker',
  OPERATOR: 'operator',
  TIMER: 'timer',
  '1C': '1c',
  IMPORT: 'import',
  FOREST: 'forest',
  EMPLOYER: 'employer',
  SUPERVISOR: 'supervisor',
  ZVONOBOT: 'zvonobot',
  INTEGRATION: 'integration',
});

module.exports = {
  INITIATORS,
};
